export const normalizeString = (
  value = ""
) => {

  return String(value)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_]/g, "");
};

export const normalizeItemKey =
  normalizeString;

/* =================================================
   STRICT ITEM ID RESOLVER
================================================= */

export const getItemPrimaryKey = (
  item = {}
) => {

  // =============================================
  // STRICT FIRESTORE item_id ONLY
  // =============================================

  const strictItemId =
    String(
      item.item_id ||

      item.id ||

      ""
    ).trim();

  if (!strictItemId) {

    console.error(
      "INVALID INVENTORY ITEM:",
      item
    );

    return null;
  }

  return strictItemId;
};

/* =================================================
   STRICT INVENTORY MAP
================================================= */

export const buildInventoryMap = (
  inventoryList = []
) => {

  const map = {};

  inventoryList.forEach(
    (item) => {

      // =============================================
      // STRICT FIRESTORE item_id ONLY
      // =============================================

      const strictItemId =
        String(
          item.item_id ||

          item.id ||

          ""
        ).trim();

      if (!strictItemId) {

        console.error(
          "INVALID INVENTORY MAP ITEM:",
          item
        );

        return;
      }

      // =============================================
      // STRICT qty ONLY
      // =============================================

      const stockQty =
        Number(
          item.qty || 0
        );

      // =============================================
      // PREVENT VALID STOCK OVERWRITE
      // =============================================

      map[strictItemId] =
        Math.max(
          Number(
            map[strictItemId] || 0
          ),

          stockQty
        );

      console.log(
        "MAP ENTRY:",
        strictItemId,
        stockQty,
        "FINAL:",
        map[strictItemId]
      );
    }
  );

  console.log(
    "FINAL INVENTORY MAP:",
    map
  );

  return map;
};

/* =================================================
   VALIDATE INVENTORY ITEM
================================================= */

export const validateInventoryItem =
  (item = {}) => {

    const errors = [];

    if (
      !item.item_id ||

      !String(
        item.item_id
      ).trim()
    ) {

      errors.push(
        "Missing item_id"
      );
    }

    if (
      !item.item_name ||

      !String(
        item.item_name
      ).trim()
    ) {

      errors.push(
        "Missing item_name"
      );
    }

    if (
      item.qty !== undefined &&

      isNaN(
        Number(item.qty)
      )
    ) {

      errors.push(
        "Invalid qty"
      );
    }

    return {

      valid:
        errors.length === 0,

      errors,
    };
  };